import { FlexContainer } from '@facephi/ui-react';
import { UserList } from '../components/userList';

const UserListPage = () => {
  return (
    <FlexContainer flexDirection="column" rowGap="2.4" flex="1">
      <UserList />
    </FlexContainer>
  );
};

export default UserListPage;
